module.exports = __webpack_public_path__ + "img/T1C_rc_18.208f4964.png";